<template>
  <div class="open-container">
    <div class="common-container">
      <com-title title="丰富专业的能力版图" brief="基于云计算、大数据核心技术，全面创新全媒体服务，助力各行业用户携手前行"></com-title>
      <div class="open-swiper">
        <swiper
          :modules="modules"
          @swiper="onSwiper"
          @slideChange="onSlideChange"
          navigation
          :slides-per-view="5"
          :space-between="30"
          :pagination="{ clickable: true }"
          autoplay 
          loop
        >
          <swiper-slide>
            <a href="##"  class="bounceInUpSlow wow li"
              data-wow-delay="0.1s">
              <icon-card :img="img1" title="移动采编" brief="融上海、融采编、融媒宝等移动采编工具集，方便融媒体日常业务"></icon-card>
            </a>
          </swiper-slide>
          <swiper-slide>
            <a href="##"  class="bounceInUpSlow wow li"
              data-wow-delay="0.15s">
              <icon-card :img="img2" title="大数据分析" brief="多维度、多指标的交叉分析能力，助力客户建立数据治理体系"></icon-card>
            </a>
          </swiper-slide>
          <swiper-slide>
            <a href="##"  class="bounceInUpSlow wow li"
              data-wow-delay="0.25s">
              <icon-card :img="img3" title="数据采集" brief="基于智能化采集标注工具和成熟的数据服务体系，交付高质量目标数据"></icon-card>
            </a>
          </swiper-slide>
          <swiper-slide>
            <a href="##"  class="bounceInUpSlow wow li"
              data-wow-delay="0.3s">
              <icon-card :img="img4" title="智能多媒体编辑" brief="多媒体内容创作协作、专业内容交付、云端剪辑等能力"></icon-card>
            </a>
          </swiper-slide>
          <swiper-slide>
            <a href="##"  class="bounceInUpSlow wow li"
              data-wow-delay="0.35s">
              <icon-card :img="img5" title="智能AI" brief="智能推荐、智能标签、敏感词、错别字等AI能力"></icon-card>
            </a>
          </swiper-slide>

          <swiper-slide>
            <a href="##">
              <icon-card :img="img6" title="虚拟化" brief="虚拟化博物馆、虚拟主播等技术能力"></icon-card>
            </a>
          </swiper-slide>
          <swiper-slide>
            <a href="##">
              <icon-card :img="img7" title="一站式直播" brief="现场拍摄直播、直播推拉流、多渠道直播分发、全终端观看"></icon-card>
            </a>
          </swiper-slide>
          <swiper-slide>
            <a href="##">
              <icon-card :img="img8" title="O2O" brief="助力实现同城、社区等多类场景下灵活适用的O2O模式"></icon-card>
            </a>
          </swiper-slide>
          <swiper-slide>
            <a href="##">
              <icon-card :img="img9" title="实名认证" brief="领先、贴心、全面、安全的用户身份信息真实性核验服务"></icon-card>
            </a>
          </swiper-slide>


          <swiper-slide>
            <a href="##">
              <icon-card :img="img10" title="一站式运营" brief="依托丰富的运营经验和工具集，为用户提供一站式托管运营服务"></icon-card>
            </a>
          </swiper-slide>
          <swiper-slide>
            <a href="##">
              <icon-card :img="img11" title="全渠道发布" brief="支持“两微一抖”在内的新媒体矩阵多渠道发布"></icon-card>
            </a>
          </swiper-slide>
          <swiper-slide>
            <a href="##">
              <icon-card :img="img12" title="游戏化运营" brief="完整的用户积分体系，游戏化活动运营工具，个性化玩法激活用户"></icon-card>
            </a>
          </swiper-slide>
          <swiper-slide>
            <a href="##">
              <icon-card :img="img13" title="内容服务" brief="为客户提供采访资源，内容创作服务"></icon-card>
            </a>
          </swiper-slide>

          <swiper-slide>
            <a href="##">
              <icon-card :img="img14" title="适老化与无障碍" brief="助力客户监测、咨询、改造网站及APP的适老化与无障碍功能"></icon-card>
            </a>
          </swiper-slide>
          <swiper-slide>
            <a href="##">
              <icon-card :img="img15" title="专有云环境" brief="构建专有云平台，帮助客户实现 IT 敏捷化改造，赋能数字化转型"></icon-card>
            </a>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>
<script setup>
import { Navigation,Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue.js';
import { ref } from 'vue'
import img1 from '@/assets/images/icon/power-img01.png'
import img2 from '@/assets/images/icon/power-img02.png'
import img3 from '@/assets/images/icon/power-img03.png'
import img4 from '@/assets/images/icon/power-img04.png'
import img5 from '@/assets/images/icon/power-img05.png'

import img6 from '@/assets/images/icon/power-img06.png'
import img7 from '@/assets/images/icon/power-img07.png'
import img8 from '@/assets/images/icon/power-img08.png'
import img9 from '@/assets/images/icon/power-img09.png'
import img10 from '@/assets/images/icon/power-img10.png'

import img11 from '@/assets/images/icon/power-img11.png'
import img12 from '@/assets/images/icon/power-img12.png'
import img13 from '@/assets/images/icon/power-img13.png'
import img14 from '@/assets/images/icon/power-img14.png'
import img15 from '@/assets/images/icon/power-img15.png'


const onSwiper = (swiper) => {
  // console.log(swiper);
};
const onSlideChange = () => {
  // console.log('slide change');
};
const modules = ref([Navigation,Pagination])
</script>
<style lang="less" scoped>
</style>